import React from 'react';
import { Section } from './ui/Section';
import { Container } from './ui/Container';
import { ClockIcon, FileXIcon, FrownIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const pains = [{
    icon: ClockIcon,
    title: 'Horas perdidas planificando',
    description: 'El tiempo personal se consume buscando recursos dispersos en internet que rara vez encajan con tu programa.'
  }, {
    icon: FileXIcon,
    title: 'Materiales inconsistentes',
    description: 'Encontrar actividades que tengan coherencia visual y pedagógica es un desafío constante.'
  }, {
    icon: FrownIcon,
    title: 'Estrés y sobrecarga',
    description: 'La presión por tener todo listo para mañana genera ansiedad y resta energía para lo importante: enseñar.'
  }];
  return <Section background="white" data-id="element-122">
      <Container data-id="element-123">
        <div className="text-center max-w-3xl mx-auto mb-16" id="nosotros" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-125">
            El Desafío Que Enfrentan los Docentes
          </h2>
          <p className="text-lg text-brand-navy-700" data-id="element-126">
            Entendemos que la docencia es exigente. Estos son los obstáculos más
            comunes que enfrentan los educadores hoy en día, y la razón por la
            que creamos nuestros recursos.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-127">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-cream-50 p-8 rounded-2xl border border-brand-cream-100 hover:shadow-lg transition-shadow duration-300" data-id="element-128">
              <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-6 text-red-600" data-id="element-129">
                <pain.icon size={28} data-id="element-130" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-brand-navy-900" data-id="element-131">
                {pain.title}
              </h3>
              <p className="text-brand-navy-700 leading-relaxed" data-id="element-132">
                {pain.description}
              </p>
            </motion.div>)}
        </div>
      </Container>
    </Section>;
}